module.exports = __webpack_public_path__ + "img/robot-empty.56d0b135.svg";